import React, { useState } from "react";
import italia from "italia";
import { validator } from "../libs/validator";
import iban from "iban";

export const RegistryContext = React.createContext(null);

// inizializzo i dati che tutti i figli del Context potranno utilizzare

export default ({ children }) => {
  // dichiarazione di tutte le variabili di stato
  const [contactBody, setContactBody] = useState({
    type: "PERSON",
    relationships: ["CUSTOMER"],
    iban: "",
    title: "",
    name: "",
    bankAccounts: [],
    legalNature: "",
    taxRepresentative: {}
  });
  const [paymentDetails, setPaymentDetails] = useState({ iban: "" });
  const [installments, setInstallments] = useState([
    {
      dueDate: { number: "30", interval: "giorni", from: "month-end" },
      amount: 100,
      iban: "",
      paymentMethod: "MP05"
    }
  ]);
  const [installmentsError, setInstallmentsError] = useState(false);
  const [vatNumber, setVatNumber] = useState("");
  const [taxId, setTaxId] = useState("");
  const [eoriNumber, setEoriNumber] = useState("");
  const [country, setCountry] = useState("");
  const [emailAddress, setEmailAddress] = useState("");
  const [pecAddress, setPecAddress] = useState("");
  const [address, setAddress] = useState({
    region: "",
    country: "",
    municipality: "",
    cap: "",
    province: "",
    street: "",
    number: ""
  });
  const [municipalityError, setMunicipalityError] = useState(null);
  const [provinceError, setProvinceError] = useState(null);
  const [capError, setCapError] = useState(null);
  const [optionCountries, setCountries] = useState([]);
  const [emailError, setEmailError] = useState(null);
  const [pecError, setPecError] = useState(null);
  const [ibanPaymentFormError, setIbanPaymentFormError] = useState(null);
  const [ibanError, setIbanError] = useState(null);
  const [taxIdError, setTaxIdError] = useState(null);
  const [vatError, setVatError] = useState(null);
  const [fullScreenCreateNew, setFullScreenCreateNew] = useState(false);
  const [isLastContactAdded, setIsLastContactAdded] = useState(false);

  // dichiarazione delle funzioni che agiscono sulla validazione dei vari campi

  const capitalizeMunicipality = (string) => {
    return `${string.charAt(0).toUpperCase()}${string.slice(1).toLowerCase()}`;
  };

  const capitalizeProvince = (string) => {
    if (string.length > 2) {
      return `${string.charAt(0).toUpperCase()}${string.slice(1).toLowerCase()}`;
    } 
    return string.toUpperCase();
    
  };

  const getMatchingCityAndState = (e) => {
    const regions = italia.comuni.regioni;
    const states = regions.flatMap((r) => r.province);
    const cities = states.flatMap((s) => s.comuni);
    let matchingCity = "";
    if (e.target !== undefined) {
      matchingCity = cities.find((city) => city.nome === capitalizeMunicipality(e.target.value));
    } else {
      matchingCity = cities.find((city) => city.nome === capitalizeMunicipality(e));
    }
    const matchingState = states.find((state) => state.comuni.includes(matchingCity));
    return {
      matchingCity: matchingCity,
      matchingState: matchingState
    };
  };

  const onBlurMunicipality = (e) => {
    if (address.country === "Italia" || e === "Italia") {
      const { matchingCity } = getMatchingCityAndState(e);
      setMunicipalityError(matchingCity === undefined ? true : false);
      setCapError(true);
      setProvinceError(true);
    }
  };

  const onBlurProvince = (e) => {
    if (address.country === "Italia" || e === "Italia") {
      const { matchingState } = getMatchingCityAndState(address.municipality);
      const insertedValue = capitalizeProvince(e.target.value);
      setProvinceError(insertedValue === matchingState?.code || insertedValue === matchingState?.nome ? false : true);
    }
  };

  const onBlurCap = (e) => {
    if (address.country === "Italia") {
      const { matchingCity } = getMatchingCityAndState(address.municipality);
      const insertedValue = e.target.value;
      const insertedFirstThree = insertedValue.substring(0, 3);
      if (!matchingCity?.cap.includes("x")) {
        setCapError(insertedValue === matchingCity?.cap ? false : true);
      } else {
        setCapError(matchingCity?.cap.includes(insertedFirstThree) ? false : true);
      }
    }
  };

  const onBlurEmail = (e) => {
    const isValidEmail = validator.isEmail(e.target.value);
    setEmailError(isValidEmail ? false : true);
  };

  const onBlurPec = (e) => {
    const isValidPec = validator.isEmail(e.target.value);
    setPecError(isValidPec ? false : true);
  };

  const onChangeCountry = (value) => {
    setAddress({ ...address, country: value });
    setMunicipalityError(value === "Italia" ? true : null);
    setProvinceError(value === "Italia" ? true : null);
    setCapError(value === "Italia" ? true : null);
  };

  const onChangeIbanPaymentForm = (e) => {
    const isValidIban = iban.isValid(e.target.value);
    setIbanPaymentFormError(isValidIban ? false : true);
  };

  // creazione dello store che contiene tutte le variabili di stato, che possiamo poi richiamare in qualsiasi componente dell'applicazione
  const registryStore = {
    contactBody: contactBody,
    setContactBody: setContactBody,
    paymentDetails: paymentDetails,
    setPaymentDetails: setPaymentDetails,
    installments: installments,
    setInstallments: setInstallments,
    installmentsError: installmentsError,
    setInstallmentsError: setInstallmentsError,
    vatNumber: vatNumber,
    setVatNumber: setVatNumber,
    taxId: taxId,
    setTaxId: setTaxId,
    eoriNumber: eoriNumber,
    setEoriNumber: setEoriNumber,
    country: country,
    setCountry: setCountry,
    emailAddress: emailAddress,
    setEmailAddress: setEmailAddress,
    pecAddress: pecAddress,
    setPecAddress: setPecAddress,
    address: address,
    setAddress: setAddress,
    ibanPaymentFormError: ibanPaymentFormError,
    setIbanPaymentFormError: setIbanPaymentFormError,
    municipalityError: municipalityError,
    setMunicipalityError: setMunicipalityError,
    provinceError: provinceError,
    setProvinceError: setProvinceError,
    capError: capError,
    setCapError: setCapError,
    optionCountries: optionCountries,
    setCountries: setCountries,
    emailError: emailError,
    setEmailError: setEmailError,
    pecError: pecError,
    setPecError: setPecError,
    onBlurMunicipality: onBlurMunicipality,
    getMatchingCityAndState: getMatchingCityAndState,
    capitalizeMunicipality: capitalizeMunicipality,
    onBlurProvince: onBlurProvince,
    onBlurCap: onBlurCap,
    onBlurEmail: onBlurEmail,
    onBlurPec: onBlurPec,
    onChangeCountry: onChangeCountry,
    onChangeIbanPaymentForm: onChangeIbanPaymentForm,
    ibanError: ibanError,
    setIbanError: setIbanError,
    taxIdError: taxIdError,
    setTaxIdError: setTaxIdError,
    vatError: vatError,
    setVatError: setVatError,
    fullScreenCreateNew: fullScreenCreateNew,
    setFullScreenCreateNew: setFullScreenCreateNew,
    isLastContactAdded: isLastContactAdded,
    setIsLastContactAdded: setIsLastContactAdded
  };

  return <RegistryContext.Provider value={registryStore}>{children}</RegistryContext.Provider>;
};
